import LogoCactus from "./LogoCactus";
import LogoMarmalade from "./LogoMarmalade";
import { Box, Stack, Typography } from "@mui/material";
import { LEGACY_THEME } from "flags";
import { useFeatureFlag } from "store/hooks/featureFlagHooks";

const SvgLogo = (props) => {
  const { isOn: legacyTheme, isLoading } = useFeatureFlag(LEGACY_THEME, {
    default: true,
  });

  return isLoading ? (
    <></>
  ) : legacyTheme ? (
    <LogoMarmalade {...props} />
  ) : (
    <LogoCactus {...props} />
  );
};

const PoweredBy = () => {
  return (
    <Stack direction={"row"} alignItems={"flex-start"} spacing={0.5}>
      <Typography variant={"subtitle2"}>{"Powered By"}</Typography>
      <Box style={{ display: "flex" }}>
        <SvgLogo height={18} variant={"wordmark"} />
      </Box>
    </Stack>
  );
};

const Logo = (props) => {
  const poweredBy = (props.variant || "").trim().toLowerCase() === "poweredby";

  return poweredBy ? <PoweredBy /> : <SvgLogo {...props} />;
};

export default Logo;
